<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="backList">系列管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>新增/修改系列</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul class="cont_btns1">
        <li>
          <el-button
            @click="backList"
            type="primary"
          >返回系列列表</el-button>
        </li>
      </ul>
      <div class="contain_header1 clr">
        <el-form
          style="width:850px;"
          ref="form"
          :model="form"
          label-width="200px"
          :rules="addFormRule"
        >
          <el-form-item
            label="系列名称"
            prop='typeName'
          >
            <el-input
              v-model="form.typeName"
              placeholder="请输入系列名称"
            ></el-input>
          </el-form-item>

          <el-form-item
            label="分类"
            prop="typeId"
          >
            <el-select multiple placeholder="请选择" v-model="form.typeId">
              <el-option
                v-for="option in typeOptions"
                :value="option.id"
                :key='option.id'
                :label="option.title"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              @click="onSubmit('form')"
              :loading="addLoading"
            >{{wordName}}</el-button>
            <el-button @click="resetForm('form')">重置</el-button>
            <el-button @click="backList">返回列表</el-button>
          </el-form-item>
        </el-form>
      </div>

    </div>

  </el-main>
</template>

<script>
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc.js";
var _ = require("lodash");
export default {
  name: "add_good",
  data() {
    return {
      typeOptions: [],
      typeOptions1:[],
      tokenData: {
        token: localStorage.getItem("api_token")
      },
      options: [],
      good: null,
      wordName: "新增",
      props: {
        value: "id",
        label: "type_name"
      },
      addFormRule: {
        typeName: [
          {
            required: true,
            message: "请输入系列名称",
            trigger: "blur"
          }
        ],
        typeId: [
          {
            required: true,
            message: "请输入系列名称",
            trigger: "blur"
          }
        ],
      },
      addLoading: false,
      fileList2: [],
      fileList3: [],
      fileList4: [],
      fileList5: [],
      form: {
        typeName: null,
        typeId: [],
      }
    };
  },
  mounted(e) {
    //初始化表单
    var that = this;
    this.page_num = 1;
    let params = {
      pageNum: 1,
      pageSize: 100,
      infoType: 1,
      noVip:1,
      token: localStorage.getItem("api_token")
    };
    that.loading = true;
    API.good_first_type_list(params)
      .then(
        function(result) {
          that.loading = false;
          if (result.key == 1000) {
            that.typeOptions = [];
            for (var i = 0; i < result.result.list.length; i++) {
              if (result.result.list[i].title != "全部") {
                that.typeOptions.push(result.result.list[i]);
              }
            }
          }
        },
        function(err) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: err.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error) {
        that.loading = false;
        that.$message.error({
          showClose: true,
          message: "请求出现异常",
          duration: 2000
        });
      });
    var good = this.$route.query.good;
    this.good = good;
    var para = {
      id: this.$route.query.id,
      token: localStorage.getItem("api_token")
    };
    if (good != null) {
      console.log(good);
      that.wordName = "修改";
      that.form.id = good.id;
      that.form.typeName = good.typeName;
      let typeId = []
      JSON.parse(good.typeId).forEach(item => {
        typeId.push(item.id)
      })
      that.form.typeId = typeId
    } else {
      that.form.status = "1";
      that.wordName = "立即创建";
    }
    // var para = {
    //   token: localStorage.getItem("api_token")
    // };
    // API.get_all_types(para)
    //   .then(
    //     function(result) {
    //       that.addLoading = false;
    //       if (result.key == 1000) {
    //         that.options = result.result.list;
    //         // resetForm();
    //       } else {
    //         that.$message.error({
    //           showClose: true,
    //           message: result.message || "登录失败",
    //           duration: 2000
    //         });
    //       }
    //     },
    //     function(err) {
    //       that.loading = false;
    //       console.error(err);
    //       that.$message.error({
    //         showClose: true,
    //         message: err.toString(),
    //         duration: 2000
    //       });
    //     }
    //   )
    //   .catch(function(error) {
    //     that.loading = false;
    //     console.error(error);
    //     that.$message.error({
    //       showClose: true,
    //       message: "请求出现异常",
    //       duration: 2000
    //     });
    //   });
  },
  computed: {},
  methods: {
    changeGoodType(e)
    {

      this.typeOptions1 = [];
      this.form.type_id = null;
      for (var i=0; i<this.typeOptions.length;i++)
      {
        if (this.typeOptions[i].noVip == this.form.no_vip)
        {
          this.typeOptions1.push(this.typeOptions[i]);
        }
      }
    },
    backList() {
      this.$router.push({
        path: "/seriesManagement"
      });
    },
    handleChange() {},
    handleRemove(file, fileList) {
      // for (var i = 0; i < this.fileList2.length; i++) {
      //   if (this.fileList2[i].name == file.name) {
      //     this.fileList2.splice(i, 1);
      //     return;
      //   }
      // }

      var list = [];
      for (var i = 0; i < this.fileList4.length; i++) {
        if (this.fileList4[i].uid && this.fileList4[i].uid != null) {
          if (this.fileList4[i].uid != file.uid) {
            list.push(this.fileList4[i]);
          }
        } else {
          if (this.fileList4[i].name != file.name) {
            list.push(this.fileList4[i]);
          }
        }
      }
      this.fileList4 = list;
      if (this.fileList4.length == 0) {
        this.form.main_pic = null;
      } else {
        this.form.main_pic = JSON.stringify(this.fileList4);
      }
    },
    handleRemove1(file, fileList) {
      var list = [];
      for (var i = 0; i < this.fileList5.length; i++) {
        if (this.fileList5[i].uid && this.fileList5[i].uid != null) {
          if (this.fileList5[i].uid != file.uid) {
            list.push(this.fileList5[i]);
          }
        } else {
          if (this.fileList5[i].name != file.name) {
            list.push(this.fileList5[i]);
          }
        }
      }
      this.fileList5 = list;
      if (this.fileList5.length == 0) {
        this.form.detail_pic = null;
      } else {
        this.form.detail_pic = JSON.stringify(this.fileList5);
      }
    },
    handlePreview(file) {},
    handleAvatarSuccess1: function(e, file) {
      if (e.key == 1000) {
        this.fileList4.push({
          name: file.name,
          uid: file.uid,
          url: e.result.map.path,
          height: e.result.map.height,
          width: e.result.map.width
        });
        this.form.main_pic = this.fileList4;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
        this.$refs.form.validateField("main_pic");
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    handleAvatarSuccess2: function(e, file) {
      if (e.key == 1000) {
        this.fileList5.push({
          uid: file.uid,
          name: file.name,
          url: e.result.map.path,
          height: e.result.map.height,
          width: e.result.map.width
        });

        this.form.detail_pic = this.fileList5;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
        this.$refs.form.validateField("detail_pic");
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    handleAvatarSuccess: function(e) {
      if (e.key == 1000) {
        this.form.list_pic = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    handleAvatarSuccessGive: function(e) {
      if (e.key == 1000) {
        this.form.give_pic = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    beforeAvatarUpload: function(e) {},
    onSubmit() {
      let that = this;
      that.$refs["form"].validate(valid => {
        if (valid) {
          let para = {
            token: localStorage.getItem("api_token"),
            typeName: that.form.typeName
          };
          para.id = that.form.id;
          let typeId = []
          that.form.typeId.forEach(item => {
            that.typeOptions.forEach(items => {
              if (item == items.id) {
                typeId.push({
                  id: items.id,
                  name: items.title
                })
              }
            })
          })
          para.typeId = JSON.stringify(typeId)
          that.addLoading = true;
          API.up_add_good_series(para)
            .then(
              function(result) {
                that.addLoading = false;
                if (result.key == 1000) {
                  if (para.id) {
                    that.$message.success({
                      showClose: true,
                      message: "修改成功",
                      duration: 1500
                    });
                  } else {
                    that.$message.success({
                      showClose: true,
                      message: "创建成功",
                      duration: 1500
                    });
                  }

                  // resetForm();
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.loading = false;
                console.error(err);
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.loading = false;
              console.error(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        } else {
          that.$message.error({
            showClose: true,
            message: "请检查是否有信息未填写",
            duration: 2000
          });
        }
      });
    },
    jumpTo(url) {
      this.defaultActiveIndex = url;
      this.$router.push(url); //用go刷新
    },
    resetForm() {
      let that = this;
      that.$refs["form"].resetFields();
    }
  }
};
</script>

<style>
.area-select .area-selected-trigger {
  padding: 0px 20px 7px 12px;
  line-height: 40px;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}
.cont_btns1 {
  float: left;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns1 li {
  display: inline-block;
}
.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}

.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}

.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}

.contain_div {
  margin: 20px;
}

.contain_header1 {
  background-color: #fff;
  padding: 40px 0 20px 40px;
  /* margin-bottom: 20px; */
}

.area-select {
  height: 40px;
}

.area-select-wrap .area-select {
  margin-left: 0px !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/good/add_seriesManagement.vue